import api from '../_helpers/APIClient'

export const Location = {
  namespaced: true,
  state: {
    prefectures: [], // 都道府県データ
    cities: {} // 都市データ
  },
  getters: {
    prefectures: state => state.prefectures,
    cities: state => state.cities
  },
  mutations: {
    UPDATE_CITIES (state, item) {
      state.cities = item
    },
    UPDATE_PREFECTURES (state, item) {
      state.prefectures = item
    }
  },
  actions: {
    /**
     * Locationデータを取得
     * @param {Object} commit
     */
    async action_FetchLocation ({ commit }) {
      const res = await api.getLocations()
      const results = res.data.data
      const prefectures = results.map(data => ({ item_id: data.id, item: data.prefecture }))
      const cities = {}
      results.forEach(data => {
        cities[data.prefecture] = data.cities.map(city => ({ item_id: city.id, item: city.city }))
      })
      commit('UPDATE_PREFECTURES', prefectures)
      commit('UPDATE_CITIES', cities)
    }
  }
}
